// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import {getRequest} from './utils/api'
import {postRequest} from './utils/api'
import {postRequestJson} from './utils/api'
import {deleteRequest} from './utils/api'
import {putRequest} from './utils/api'
import {putRequestJson} from './utils/api'
import {initMenu} from './utils/utils'
import {isNotNullORBlank} from './utils/utils'
import './utils/filter_utils'
import 'font-awesome/css/font-awesome.min.css'
import Bus from './bus.js'
const adminApi =require( './apiList.js');
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.config.productionTip = false;
Vue.use(ElementUI, { size: 'medium' })
Vue.use(VueQuillEditor);


Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.postRequestJson = postRequestJson;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.putRequestJson = putRequestJson;
Vue.prototype.isNotNullORBlank = isNotNullORBlank;

Vue.prototype.Bus = Bus;
Vue.prototype.adminApi = adminApi;

router.beforeEach((to, from, next)=> {
    if (to.name === 'Login') {
      next();
      return;
    }
    var name = store.state.user.name;
    if (name === '未登录') {
      if (to.meta.requireAuth || to.name == null) {
        next({path: '/', query: {redirect: to.path}})
      } else {
        next();
      }
    } else {
      initMenu(router, store);
      next();
    }
  }
);

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js